import { useRef } from 'react';
import { useDataConfig } from './use-data-config';

export const useRetryRequestWithFailCount = (retryNumber = 2) => {
  const { pollingInterval } = useDataConfig();
  const failCount = useRef(0);

  return {
    refetchInterval: (failCount.current >= retryNumber ? false : pollingInterval) as false | number,
    retry: () => {
      if (failCount.current >= retryNumber) {
        return false;
      }

      failCount.current += 1;
      return failCount.current < retryNumber;
    },
  };
};
